export const ROLE_CHAMPION = 21283819;
export const ROLE_COMMUNITIES_MANAGER = 21280499;
export const ROLE_USER = 21280500;

export function isCommunities(id) {
  if (id === ROLE_COMMUNITIES_MANAGER) {
    return true;
  }
  return false;
}

export function isChampion(id) {
  if (id === ROLE_CHAMPION) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/constants/roles.js